import { useSyncExternalStore } from 'react';

/** The breakpoint where overlays switch to full-screen app surfaces. */
const MOBILE_QUERY = '(max-width: 768px)';

function subscribe(onChange: () => void): () => void {
  // jsdom has no matchMedia; treat the test environment as static desktop.
  if (typeof window.matchMedia !== 'function') return () => undefined;
  const mql = window.matchMedia(MOBILE_QUERY);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

function getSnapshot(): boolean {
  if (typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

/** True below the shared 768px breakpoint, tracking live viewport changes. */
export function useIsMobileLayout(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot);
}
